<template>
    <div>
        <Toast />
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-d-flex p-jc-between p-mb-2">
                        <h4>{{ $t('Banner.list.header') }}</h4>
                        <!-- <div>
                            <router-link to="/add-banner">
                                <Button :label="$t('Banner.addnew_banner')" icon="pi pi-plus" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2"></Button>
                            </router-link>
                        </div> -->
                    </div>
                    <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" data-key="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                        <ConfirmDialog group="dialog" />

                        <template #empty>등록된 정보가 없습니다.</template>
                        <template #loading>로딩 중입니다. 잠시만 기다려주세요. </template>
                        <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                        <Column field="Sl. No." :header="$t('Banner.list.No')" style="min-width: 3rem" class="n-wrap">
                            <template #body="{ index }">
                                <span class="p-column-title">Sl. No.</span>
                                {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                            </template>
                        </Column>
                        <!-- <Column field="Change Order" :header="$t('Banner.list.changeorder')" style="min-width: 12rem" class="n-wrap">
                            <template #body="{ data }">
                                <span class="p-column-title">Change Order</span>
                                <p style="display: none">{{ data.status }}</p>
                                <div style="display: flex">
                                    <Button label="" icon="pi pi-arrow-up" class="p-button-plain p-button-text p-mr-2 p-mb-2" @click="up(data.id)" />
                                    <Button label="" icon="pi pi-arrow-down" class="p-button-plain p-button-text p-mr-2 p-mb-2" @click="down(data.id)" />
                                </div>
                            </template>
                        </Column> -->
                        <Column field="Image" :header="$t('Banner.list.image')" style="min-width: 12rem" class="n-wrap">
                            <template #body="{ data }">
                                <span class="p-column-title">Image</span>
                                <span v-if="data.image_url !== ''">
                                    <img :src="image_url + data.image_url" :alt="data.image_url" class="product-image" />
                                </span>
                                <span v-else>
                                    <p>이미지 없음</p>
                                </span>
                            </template>
                        </Column>
                        <Column field="Title" :header="$t('Banner.list.title')" style="min-width: 12rem" class="n-wrap">
                            <template #body="{ data }">
                                <span class="p-column-title">Title</span>
                                {{ data.title }}
                            </template>
                        </Column>
                        <Column field="redirection_url" :header="$t('Banner.list.url')" style="min-width: 12rem" class="n-wrap">
                            <template #body="{ data }">
                                <span class="p-column-title">Title</span>
                                {{ data.redirection_url }}
                            </template>
                        </Column>
                        <Column field="Exposure" :header="$t('Banner.list.status')" style="min-width: 12rem" class="n-wrap">
                            <template #body="{ data }">
                                <span class="p-column-title">Exposure</span>
                                <!-- {{ data.id }}
                                {{ data.status }} -->
                                <InputSwitch v-model="data.status" trueValue="active" @change="switchValue(data.id, data.status)" />
                            </template>
                        </Column>
                        <!-- <Column field="Creation-Date" :header="$t('Banner.list.created_dt')" style="min-width: 12rem" class="n-wrap">
                            <template #body="{ data }">
                                <span class="p-column-title">Creation-Date</span>
                                {{ FormatDate(data.create_date) }}
                            </template>
                        </Column> -->
                        <Column field="Actions" :header="$t('Banner.list.see_more')" class="n-wrap" style="width: 10%">
                            <template #body="{ data }">
                                <span class="p-column-title">Actions</span>
                                <p style="display: none">{{ data.status }}</p>
                                <div style="display: flex">
                                    <Button label="info" class="n-wrap p-button2 p-mr-2 p-mb-2" @click="up(data.id)" :disabled="results.indexOf(data) == 0 ? true : false">
                                        <i class="pi pi-caret-up p-mr-2"></i>
                                    </Button>

                                    <Button label="info" class="n-wrap p-button2 p-mr-2 p-mb-2" @click="down(data.id)" :disabled="results.length - 1 == results.lastIndexOf(data) ? true : false">
                                        <i class="pi pi-caret-down p-mr-2"></i>
                                    </Button>
                                    <router-link :to="'/BannerManagemet/edit-banner/' + data.id">
                                        <Button label="help" class="n-wrap p-button2 p-mr-2 p-mb-2"> <i class="pi pi-user-edit p-mr-2"></i></Button>
                                    </router-link>

                                    <!-- <Button icon="pi pi-trash" class="n-wrap p-button p-mr-2 p-mb-2" @click="confirm(data.id)" /> -->
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                    <div class="p-paginator p-component p-paginator-bottom">
                        <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                            <span class="p-paginator-icon pi pi-angle-double-left"></span>
                            <span class="p-ink"></span>
                        </button>
                        <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                            <span class="p-paginator-icon pi pi-angle-left"></span>
                            <span class="p-ink"></span>
                        </button>
                        <span class="p-paginator-pages">
                            <button v-for="(page, index) in pagination.total_pages" :key="index" @click="paginate(page)" class="p-paginator-page p-paginator-element p-link" :class="{ 'p-highlight': page === pagination.current_page }" type="button">
                                {{ page }}<span class="p-ink"></span>
                            </button>
                        </span>
                        <button
                            @click="paginate(pagination.current_page + 1)"
                            :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                            class="p-paginator-next p-paginator-element p-link"
                            type="button"
                            :disabled="pagination.current_page === pagination.total_pages"
                        >
                            <span class="p-paginator-icon pi pi-angle-right"></span>
                            <span class="p-ink"></span>
                        </button>
                        <button
                            @click="paginate(pagination.total_pages)"
                            :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                            :disabled="pagination.current_page === pagination.total_pages"
                            class="p-paginator-last p-paginator-element p-link"
                            type="button"
                        >
                            <span class="p-paginator-icon pi pi-angle-double-right"></span>
                            <span class="p-ink"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router';
import BannerService from '../../service/API/BannerService';
import axios from 'axios';
import moment from 'moment';
// import { response } from 'express';
export default {
    data() {
        return {
            results: [],
            title: '',
            loading1: false,
            deletedID: '',
            result: '',
            image_url: '',
            create_date: '',
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            totalrecords: '',
            id: '',
            status: '',
            redirection_url: '',
        };
    },
    created() {
        this.bannerService = new BannerService();
    },
    mounted() {
        const route = useRoute();
        console.log(route.params);
        this.getBannerLists();
    },
    methods: {
        getBannerLists() {
            const BannerlistParams = {
                page: 1,
                limit: this.pagination.pagination_limit,
            };
            this.loading1 = true;
            this.bannerService
                .getBannerList(BannerlistParams)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch((err) => console.log(err));
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },

        paginate(page) {
            this.loading1 = true;
            this.bannerService
                .getBannerList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    name: this.name,
                    email: this.email,
                })
                .then((res) => {
                    this.results = res.data.result;
                    this.pagination.current_page = page;
                    this.loading1 = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },

        switchValue(ids, switchstatus) {
            console.log(ids, switchstatus);
            var self = this;
            axios({ method: 'post', url: '/api/v1/admin/banner/status-update', data: { banner_id: ids, status: switchstatus === false ? 'deleted' : 'active' } }).then(function (response) {
                if (response.data.message === 'lastrecord') {
                    self.$toast.add({ severity: 'error', summary: '오류가 발생했습니다.', detail: '최소 1개의 배너는 활성화 되어야 합니다.', life: 3000 });
                    self.getBannerLists();
                } else {
                    // this.$router.push({ name: 'Banner Management' });
                    setTimeout(() => {
                        self.$toast.add({ severity: 'info', summary: '확인.', detail: '배너 상태가 성공적으로 업데이트되었습니다.', life: 3000 });
                        self.getBannerLists();
                    }, 500);

                    console.log(response);
                }
            });
        },
        up(ids) {
            axios({ method: 'post', url: '/api/v1/admin/banner/sort/up', data: { banner_id: ids } }).then(function (response) {
                console.log(response);
            });
            setTimeout(() => {
                // this.bannerService.getBannerList().then((data) => {
                //     this.results = data;
                //     console.log(data);
                //     this.loading1 = false;
                // });
                this.getBannerLists();
            }, 500);
        },
        down(ids) {
            axios({ method: 'post', url: '/api/v1/admin/banner/sort/down', data: { banner_id: ids } }).then(function (response) {
                console.log(response);
            });
            setTimeout(() => {
                // this.bannerService.getBannerList().then((data) => {
                //     this.results = data;
                //     console.log(data);
                //     this.loading1 = false;
                // });
                this.getBannerLists();
            }, 500);
        },
    },

    searchBannner() {
        if (this.dropdownValue === '' && this.calendarValue1 === '' && this.calendarValue2 === '') {
            this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '검색 필드를 입력해주세요.', life: 2000 });
        } else {
            console.log(this.dropdownValue?.name);
            this.bannerService
                .getBannerList(this.dropdownValue?.name, this.calendarValue1, this.calendarValue2)
                .then((data) => {
                    this.products = data;
                    this.loading1 = false;
                    console.log(data);
                })
                .catch(() => {
                    this.products = [];
                    this.loading1 = false;
                });
        }
    },
    reInitialize() {
        this.dropdownValue = null;
        this.calendarValue1 = null;
        this.calendarValue2 = null;
        this.title = null;
        this.bannerService
            .getBannerList(this.title, this.dropdownValue, this.calendarValue1, this.calendarValue2)
            .then((data) => {
                this.results = data;
                this.loading1 = false;
                console.log(data);
            })
            .catch((err) => console.log(err));
    },
    today() {
        const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
        this.calendarValue1 = utc;
        this.calendarValue2 = utc;
    },
    lastweek() {
        const date = new Date();
        const edate = new Date();
        date.setDate(date.getDate() - 7);
        const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
        this.calendarValue1 = startDate;
        this.calendarValue2 = edate;
    },
    lastmonth() {
        const date = new Date();
        const edate = new Date();
        date.setDate(date.getDate() - 31);
        const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
        this.calendarValue1 = startDate;
        this.calendarValue2 = edate;
    },
    lastsixmonth() {
        const date = new Date();
        const edate = new Date();
        date.setDate(date.getDate() - 182);
        const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
        this.calendarValue1 = startDate;
        this.calendarValue2 = edate;
    },
    lastyear() {
        const date = new Date();
        const edate = new Date();
        date.setDate(date.getDate() - 365);
        const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
        this.calendarValue1 = startDate;
        this.calendarValue2 = edate;
    },
    confirm(id) {
        this.$confirm.require({
            group: 'dialog',
            header: '확인',
            message: '삭제하시겠습니까?',
            icon: 'pi pi-trash',
            acceptLabel: '확인',
            rejectLabel: '취소',
            accept: () => {
                axios({ method: 'get', url: `/api/v1/admin/banner/delete/${id}` }).then(function (response) {
                    this.getBannerLists();
                    console.log(response);
                });
                this.$toast.add({ severity: 'info', summary: '삭제되었', detail: '성공적으로 삭제되었습니다.', life: 3000 });
            },
            reject: () => {
                this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '오류가 발생했습니다.', life: 3000 });
            },
        });
        setTimeout(() => {
            this.bannerService.getBannerList().then((data) => {
                this.products = data;
                console.log(data);
                this.loading1 = false;
            });
        }, 2000);
    },
    onRowExpand(event) {
        this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
    },
    onRowCollapse(event) {
        this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    },
    formatCurrency(value) {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },
    formatDate(value) {
        const date = new Date(value);
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        var hr = date.getHours();
        var min = date.getMinutes();
        var sec = date.getSeconds();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return (value = yyyy + '.' + mm + '.' + dd + ' ' + ' ' + hr + ':' + min + ':' + sec);
    },
    showModal(id) {
        console.log(id);
        this.isModalVisible = true;
        this.deletedID = id;
    },
    closeModal() {
        this.$toast.add({ severity: 'warn', summary: 'Canceled', detail: 'Message Detail', life: 3000 });
        this.isModalVisible = false;
    },
    FormatDate(value) {
        if (value) {
            return moment(String(value)).format('YYYY/MM/DD');
        }
    },
};
</script>

<style scoped lang="scss">
::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: 0.5rem;
    background-color: #d8dadc;

    .p-progressbar-value {
        background-color: #607d8b;
    }
}

::v-deep(.p-datatable .p-sortable-column .p-column-title) {
    display: block;
}

.p-datatable .p-column-filter {
    display: none;
}

.table-header {
    display: flex;
    justify-content: space-between;
}

.customer-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-qualified {
        background: #c8e6c9;
        color: #256029;
    }

    &.status-unqualified {
        background: #ffcdd2;
        color: #c63737;
    }

    &.status-negotiation {
        background: #feedaf;
        color: #8a5340;
    }

    &.status-new {
        background: #b3e5fc;
        color: #23547b;
    }

    &.status-renewal {
        background: #eccfff;
        color: #694382;
    }

    &.status-proposal {
        background: #ffd8b2;
        color: #805b36;
    }
}

.p-progressbar-value.ui-widget-header {
    background: #607d8b;
}

@media (max-width: 640px) {
    .p-progressbar {
        margin-top: 0.5rem;
    }
}

.product-image {
    width: 50px;
    height: 50px;
    // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
    padding: 1rem;
}

.product-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-instock {
        background: #c8e6c9;
        color: #256029;
    }

    &.status-outofstock {
        background: #ffcdd2;
        color: #c63737;
    }

    &.status-lowstock {
        background: #feedaf;
        color: #8a5340;
    }
}

.order-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.order-delivered {
        background: #c8e6c9;
        color: #256029;
    }

    &.order-cancelled {
        background: #ffcdd2;
        color: #c63737;
    }

    &.order-pending {
        background: #feedaf;
        color: #8a5340;
    }

    &.order-returned {
        background: #eccfff;
        color: #694382;
    }
}

.p-datatable {
    .p-sortable-column {
        &.p-highlight {
            &:hover {
                background: rgb(216 217 243);
                color: #464df2;
            }
        }
    }
}

.true-icon {
    color: #256029;
}

.false-icon {
    color: #c63737;
}

.w-100 {
    width: 100%;
}

.p-button {
    background: white;
    // border: 1px solid #0A0A0A;
    color: black;
}
</style>
